// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host:not(:host(.visible)) {
  display: none;
}

:host(.visible) {
  display: block;
}

.validation-error-row {
  margin: 0;
  padding: 0;
}`, "",{"version":3,"sources":["webpack://./../shared/ng/modules/validation/components/validation/validation-error.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA;EACI,SAAA;EACA,UAAA;AACJ","sourcesContent":[":host:not(:host(.visible)) {\n    display: none;\n};\n\n:host(.visible) {\n    display: block;\n}\n\n.validation-error-row {\n    margin: 0;\n    padding: 0;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
